import { TransformTableData, DynamicValue } from './types';

export class TableService {

  transformTableData<T>(data: T[] = [], dynamicKey: string): T[] {
    const result: T[] = JSON.parse(JSON.stringify(data));
    if (result.length === 0) {
      return result;
    }
    for (const sample of result) {
      Object.entries((sample as TransformTableData)[dynamicKey]).forEach(([key, value]) => {
        (sample as DynamicValue)[`${dynamicKey}_${key}`] = value;
      });
    }
    return result;
  }

}
